// Automatically generated door styles gallery database
const CW_GALLERY_DATA = [
  {
    "style": "Dalton",
    "color": "Accessible Beige",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-accessible-beige-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Accessible Beige",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-accessible-beige-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Alabaster",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-alabaster-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Alabaster",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-alabaster-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Anonymous",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-anonymous-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Anonymous",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-anonymous-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Creamy",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-creamy-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Creamy",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-creamy-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Cyberspace",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-cyberspace-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Cyberspace",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-cyberspace-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Dorian Gray",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-dorian-gray-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Dorian Gray",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-dorian-gray-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Eventide",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-eventide-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Eventide",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-eventide-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Gale Force",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-gale-force-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Gale Force",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-gale-force-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Pewter Green",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-pewter-green-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Pewter Green",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-pewter-green-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Poolhouse",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-poolhouse-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Poolhouse",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-poolhouse-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Pure White",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-pure-white-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Pure White",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-pure-white-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Repose Gray",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-repose-gray-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Repose Gray",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-repose-gray-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Retreat",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-retreat-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Retreat",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-retreat-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Silver Strand",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-silver-strand-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Silver Strand",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-silver-strand-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Smoky Blue",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-smoky-blue-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Smoky Blue",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-smoky-blue-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Software",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-software-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Software",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-software-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "TCW White",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-tcw-white-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "TCW White",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-tcw-white-1-25.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Tricorn Black",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-dalton-tricorn-black-0-5.jpeg"
  },
  {
    "style": "Dalton",
    "color": "Tricorn Black",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-dalton-tricorn-black-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Accessible Beige",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-accessible-beige-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Accessible Beige",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-accessible-beige-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Alabaster",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-alabaster-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Alabaster",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-alabaster-1-25.png"
  },
  {
    "style": "Isabella",
    "color": "Anonymous",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-anonymous-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Anonymous",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-anonymous-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Creamy",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-creamy-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Creamy",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-creamy-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Cyberspace",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-cyberspace-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Cyberspace",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-cyberspace-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Dorian Gray",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-dorian-gray-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Dorian Gray",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-dorian-gray-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Eventide",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-eventide-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Eventide",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-eventide-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Gale Force",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-gale-force-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Gale Force",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-gale-force-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Pewter Green",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-pewter-green-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Pewter Green",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-pewter-green-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Poolhouse",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-poolhouse-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Poolhouse",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-poolhouse-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Pure White",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-pure-white-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Pure White",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-pure-white-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Repose Gray",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-repose-gray-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Repose Gray",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-repose-gray-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Retreat",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-retreat-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Retreat",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-retreat-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Silver Strand",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-silver-strand-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Silver Strand",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-silver-strand-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Smoky Blue",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-smoky-blue-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Smoky Blue",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-smoky-blue-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Software",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-software-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Software",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-software-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "TCW White",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-tcw-white-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "TCW White",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-tcw-white-1-25.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Tricorn Black",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-isabella-tricorn-black-0-5.jpeg"
  },
  {
    "style": "Isabella",
    "color": "Tricorn Black",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-isabella-tricorn-black-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Accessible Beige",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-accessible-beige-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Accessible Beige",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-accessible-beige-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Alabaster",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-alabaster-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Alabaster",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-alabaster-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Anonymous",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-anonymous-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Anonymous",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-anonymous-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Creamy",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-creamy-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Creamy",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-creamy-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Cyberspace",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-cyberspace-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Cyberspace",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-cyberspace-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Dorian Gray",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-dorian-gray-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Dorian Gray",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-dorian-gray-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Eventide",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-eventide-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Eventide",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-eventide-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Gale Force",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-gale-force-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Gale Force",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-gale-force-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Pewter Green",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-pewter-green-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Pewter Green",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-pewter-green-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Poolhouse",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-poolhouse-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Poolhouse",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-poolhouse-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Pure White",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-pure-white-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Pure White",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-pure-white-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Repose Gray",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-repose-gray-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Repose Gray",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-repose-gray-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Retreat",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-retreat-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Retreat",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-retreat-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Silver Strand",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-silver-strand-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Silver Strand",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-silver-strand-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Smoky Blue",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-smoky-blue-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Smoky Blue",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-smoky-blue-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Software",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-software-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Software",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-software-1-25.png"
  },
  {
    "style": "Midtown",
    "color": "TCW White",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-tcw-white-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "TCW White",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-tcw-white-1-25.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Tricorn Black",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-midtown-tricorn-black-0-5.jpeg"
  },
  {
    "style": "Midtown",
    "color": "Tricorn Black",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-midtown-tricorn-black-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Accessible Beige",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-accessible-beige-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Accessible Beige",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-accessible-beige-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Alabaster",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-alabaster-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Alabaster",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-alabaster-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Anonymous",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-anonymous-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Anonymous",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-anonymous-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Creamy",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-creamy-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Creamy",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-creamy-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Cyberspace",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-cyberspace-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Cyberspace",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-cyberspace-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Dorian Gray",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-dorian-gray-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Dorian Gray",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-dorian-gray-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Eventide",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-eventide-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Eventide",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-eventide-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Gale Force",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-gale-force-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Gale Force",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-gale-force-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Pewter Green",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-pewter-green-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Pewter Green",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-pewter-green-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Poolhouse",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-poolhouse-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Poolhouse",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-poolhouse-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Pure White",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-pure-white-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Pure White",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-pure-white-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Repose Gray",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-repose-gray-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Repose Gray",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-repose-gray-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Retreat",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-retreat-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Retreat",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-retreat-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Silver Strand",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-silver-strand-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Silver Strand",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-silver-strand-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Smoky Blue",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-smoky-blue-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Smoky Blue",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-smoky-blue-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Software",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-software-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Software",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-software-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "TCW White",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-tcw-white-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "TCW White",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-tcw-white-1-25.jpeg"
  },
  {
    "style": "Revere",
    "color": "Tricorn Black",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-revere-tricorn-black-0-5.jpeg"
  },
  {
    "style": "Revere",
    "color": "Tricorn Black",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-revere-tricorn-black-1-25.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Accessible Beige",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-accessible-beige-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Accessible Beige",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-accessible-beige-1-25.jpg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Alabaster",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-alabaster-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Alabaster",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-alabaster-1-25.jpg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Anonymous",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-anonymous-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Anonymous",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-anonymous-1-25.jpg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Creamy",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-creamy-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Creamy",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-creamy-1-25.jpg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Cyberspace",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-cyberspace-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Cyberspace",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-cyberspace-1-25.jpg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Dorian Gray",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-dorian-gray-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Dorian Gray",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-dorian-gray-1-25.jpg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Eventide",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-eventide-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Eventide",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-eventide-1-25.jpg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Gale Force",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-gale-force-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Gale Force",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-gale-force-1-25.jpg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Pewter Green",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-pewter-green-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Pewter Green",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-pewter-green-1-25.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Poolhouse",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-poolhouse-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Poolhouse",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-poolhouse-1-25.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Pure White",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-pure-white-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Pure White",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-pure-white-1-25.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Repose Gray",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-repose-gray-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Repose Gray",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-repose-gray-1-25.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Retreat",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-retreat-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Retreat",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-retreat-1-25.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Silver Strand",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-silver-strand-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Silver Strand",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-silver-strand-1-25.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Smoky Blue",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-smoky-blue-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Smoky Blue",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-smoky-blue-1-25.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Software",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-software-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Software",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-software-1-25.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "TCW White",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-tcw-white-0-5.png"
  },
  {
    "style": "Skinny Shaker",
    "color": "TCW White",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-tcw-white-1-25.jpg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Tricorn Black",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-skinny-shaker-tricorn-black-0-5.jpeg"
  },
  {
    "style": "Skinny Shaker",
    "color": "Tricorn Black",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-skinny-shaker-tricorn-black-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Accessible Beige",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-accessible-beige-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Accessible Beige",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-accessible-beige-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Alabaster",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-alabaster-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Alabaster",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-alabaster-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Anonymous",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-anonymous-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Anonymous",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-anonymous-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Creamy",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-creamy-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Creamy",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-creamy-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Cyberspace",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-cyberspace-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Cyberspace",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-cyberspace-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Dorian Gray",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-dorian-gray-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Dorian Gray",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-dorian-gray-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Eventide",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-eventide-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Eventide",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-eventide-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Gale Force",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-gale-force-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Gale Force",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-gale-force-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Pewter Green",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-pewter-green-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Pewter Green",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-pewter-green-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Poolhouse",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-poolhouse-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Poolhouse",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-poolhouse-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Pure White",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-pure-white-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Pure White",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-pure-white-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Repose Gray",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-repose-gray-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Repose Gray",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-repose-gray-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Retreat",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-retreat-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Retreat",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-retreat-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Silver Strand",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-silver-strand-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Silver Strand",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-silver-strand-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Smoky Blue",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-smoky-blue-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Smoky Blue",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-smoky-blue-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Software",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-software-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Software",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-software-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "TCW White",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-tcw-white-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "TCW White",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-tcw-white-1-25.jpeg"
  },
  {
    "style": "Slab",
    "color": "Tricorn Black",
    "overlay": 0.5,
    "overlayText": "1/2\" Overlay",
    "filename": "gallery-slab-tricorn-black-0-5.jpeg"
  },
  {
    "style": "Slab",
    "color": "Tricorn Black",
    "overlay": 1.25,
    "overlayText": "1 1/4\" Overlay",
    "filename": "gallery-slab-tricorn-black-1-25.jpeg"
  }
];
